import commonApi from '@/api/api.common'
import channelApi from '@/api/api.channel'
export default [
  {
    type: 'select',
    placeholder: '状态',
    filed: 'status',
    default: '',
    query: commonApi.forbidden_select
  },
  {
    type: 'input',
    placeholder: '客户名称',
    filed: 'name',
    default: ''
  },
  {
    type: 'select',
    placeholder: '所属渠道商',
    filed: 'distributorId',
    default: '',
    query: channelApi.distributor_select
  }
]
